import { render, staticRenderFns } from "./ReplenishmentView.vue?vue&type=template&id=56efe931"
import script from "./ReplenishmentView.vue?vue&type=script&lang=js"
export * from "./ReplenishmentView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports